module.exports = __webpack_public_path__ + "static/img/bird.09139ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/bird.png
// module id = FZlV
// module chunks = 4